import React, { createContext, useContext, useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';

export const TimeContext = createContext<Dayjs>(dayjs());

export const TimeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [now, setNow] = useState(dayjs());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(dayjs());
    }, 60_000);

    return () => clearInterval(interval);
  }, []);

  return <TimeContext.Provider value={now}>{children}</TimeContext.Provider>;
};

export const useRelativeTime = () => useContext(TimeContext);
